'use strict';
var recaptcha = {
    init: function () {

        //Contact us page
        $('#contactbtn').on('click', function (e) {            
            var captchaField = $(this).parents('form').find("input[name='google_captcha_token']");
            if (captchaField.length && $(this).parents('form').valid()) {
                if (captchaField.val() == ''||captchaField.data('error')==='true') {
                    e.preventDefault();
                    var siteKey = captchaField.data('sitekey');
                    grecaptcha.ready(function() {
                        grecaptcha.execute(siteKey, {action: 'ContactUsPage'}).then(function(token){
                            if(token) {
                                captchaField.val(token);
                                $('#contactbtn').trigger('click');
                            }
                        });
                    });
                }
            }else if($(this).parents('form').valid()){

            }
        });  
    }
}

module.exports = recaptcha;



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/recaptcha.js